import { render, staticRenderFns } from "./TopicKV.vue?vue&type=template&id=3a5c9ad0&scoped=true"
import script from "./TopicKV.vue?vue&type=script&lang=js"
export * from "./TopicKV.vue?vue&type=script&lang=js"
import style0 from "./TopicKV.vue?vue&type=style&index=0&id=3a5c9ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c9ad0",
  null
  
)

export default component.exports